import React from 'react'
import { User } from '@supabase/supabase-js'
import CityForm from "../cityForm/cityForm";
import TeamManagement from "../teamManagement/teamManagement";
import NewsManagement from "../newsManagement/newsManagement";
import Header from "../../header/header";

interface AdminPageProps {
    user: User
}

const adminPageMenu = [
    {
        name: 'Cities & counties',
        link: '/admin/geo'
    },
    {
        name: 'News',
        link: '/admin/news'
    },
    {
        name: 'Teams',
        link: '/admin/teams'
    },
    {
        name: 'Matches',
        link: '/admin/matches'
    }
]

const AdminPage: React.FC<AdminPageProps> = ({ user }) => {
    return (
        <>
            <Header title={'Admin panel'} menu={adminPageMenu}/>
            <main>
                {/*<h1>Welcome, {user.identities?.[1]?.identity_data?.name || 'User'}!</h1>*/}
                <h2>City Management</h2>
                <CityForm />
                <TeamManagement />
                <NewsManagement />
            </main>
        </>
    )
}

export default AdminPage